import {
  Table as UITable,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatAndConvertTimezoneDateTime } from "@/utils/format-date";
import { formatToBRL } from "@/utils/formatToMoney";

import type { IAggregationsPreview } from "src/@types/deposit-reconciliation";
import { BatchStatusBadge } from "../../batches/components/status-badge";
import { TEXTS } from "../../../utils/messages";

export default function PreviewTable({ rows }: { rows: IAggregationsPreview[] }) {
  return (
    <div className="border border-slate-200 rounded-md bg-white">
      <div className="border-b border-slate-200 px-3 py-2 bg-slate-50 flex items-center justify-between">
        <h3 className="font-semibold text-sm text-slate-700">
          Últimas conciliações do período
        </h3>
        <span className="text-xs text-slate-500">
          {rows.length} {rows.length === 1 ? "conciliação" : "conciliações"}
        </span>
      </div>
      <UITable>
        <TableHeader>
          <TableRow>
            <TableHead className="text-xs">Conciliação</TableHead>
            <TableHead className="text-xs">Loja</TableHead>
            <TableHead className="text-xs">{TEXTS.TABLE.CONCILIATED_AT}</TableHead>
            <TableHead className="text-xs">{TEXTS.TABLE.CONCILIATED_BY}</TableHead>
            <TableHead className="text-xs text-right">Total</TableHead>
            <TableHead className="text-xs">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-xs text-center text-slate-500 h-16">
                Nenhuma conciliação no período.
              </TableCell>
            </TableRow>
          ) : (
            rows.map(r => (
              <TableRow key={r.id}>
                <TableCell className="text-xs font-mono">#{r.id}</TableCell>
                <TableCell className="text-xs">
                  {r.storeCode}
                  {r.storeName ? ` — ${r.storeName}` : ""}
                </TableCell>
                <TableCell className="text-xs">{formatAndConvertTimezoneDateTime(r.committedAt ?? r.createdAt)}</TableCell>
                <TableCell className="text-xs">{r.createdByName ?? r.createdByEmail}</TableCell>
                <TableCell className="text-xs text-right font-medium">
                  {formatToBRL(r.totalAmount)}
                </TableCell>
                <TableCell className="text-xs">
                  <BatchStatusBadge status={r.status} />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </UITable>
    </div>
  );
}
